/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
// libraries
import Slider from '@mui/material/Slider';
import Image from 'next/image';
import Link from 'next/link';
// import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FaBath, FaBed, FaCar, FaRulerCombined, FaTh, FaThList, FaTrashAlt } from 'react-icons/fa';
import { IoCloseSharp, IoFilterOutline } from 'react-icons/io5';
import { TailSpin } from 'react-loader-spinner';
import Select from 'react-select';
import { IconLinkedin } from '../../../../../assets';
// utils
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { motion } from 'framer-motion';
import { isMobile } from 'react-device-detect';
import { HiMapPin } from 'react-icons/hi2';
import Mapa from '../../../../../components/pieces/mapa/mapa';
import { customSelectPropertiesStyles } from '../../../../../components/pieces/welcome/WelcomePieces.mocks';
import { getManagerId } from '../../../../../services/properties';
import { district, getEmpreendimentoById } from '../../../../../services/selectors';
import { isEmpreendimentoVisibleOnSite } from '../../../../../utils/empreendimentos';
const CardApartament = dynamic(() => import('../../../../../components/cards/apartament/CardApartament'), { ssr: false });
const CardApartament1 = dynamic(() => import('../../../../../components/cards/apartament/CardApartament1'), { ssr: false });
const CardApartament3 = dynamic(() => import('../../../../../components/cards/apartament/CardApartament3'), { ssr: false });
const CardApartamentHorizontal = dynamic(() => import('../../../../../components/cards/apartament/CardApartamentHorizontal'), { ssr: false });

import { trackLead } from '../../../../../components/whatsAppButton/WhatsAppButton';
import {
    formatSelects,
    hexToRgba,
    isColorLight,
    toPrice,
    useWindowSize
} from '../../../../../utils/FunctionsGlobals';
import styles from './ListPiecesProperties.module.css';

const DEBOUNCE_MS = 2000;   // 1 segundo
const fallbackEmpreendimentoImage = 'https://fotos.sobressai.com.br/Fotos/imovel_sem_foto.jpg';

const stripHtmlText = (value: string | null | undefined) =>
    String(value || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();

const uniqueFeatureList = (items: string[]) => {
    const seen = new Set<string>();
    const normalized: string[] = [];

    items.forEach((item) => {
        const clean = stripHtmlText(item);
        if (!clean) return;
        const key = clean.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);
        normalized.push(clean);
    });

    return normalized;
};

const extractEmpreendimentoCaracteristicas = (empreendimento: any) => {
    const fromApi = Array.isArray(empreendimento?.caracteristicas_detalhes)
        ? empreendimento.caracteristicas_detalhes
            .map((item: any) => stripHtmlText(item?.nome))
            .filter(Boolean)
        : [];

    if (fromApi.length > 0) {
        return uniqueFeatureList(fromApi).slice(0, 8);
    }

    const fallbackTokens = stripHtmlText(
        empreendimento?.descricao || empreendimento?.Descricao_interna || empreendimento?.meta_description
    )
        .split(/[.;,|]/)
        .map((item) => item.trim())
        .filter((item) => item.length >= 3 && item.length <= 42 && item.split(/\s+/).length <= 6);

    return uniqueFeatureList(fallbackTokens).slice(0, 8);
};

const parseAreaValue = (value: any) => {
    if (value === null || value === undefined) return 0;
    const normalized = Number(String(value).replace(',', '.').replace(/[^\d.]/g, ''));
    return Number.isFinite(normalized) && normalized > 0 ? normalized : 0;
};

const parsePositiveNumber = (value: any) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

const formatCurrency = (value: number) =>
    new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        maximumFractionDigits: 0
    }).format(value);

const formatAreaNumber = (value: number) =>
    new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: value % 1 === 0 ? 0 : 1,
        maximumFractionDigits: value % 1 === 0 ? 0 : 1
    }).format(value);

const formatPriceRange = (minValue: any, maxValue: any) => {
    const min = parsePositiveNumber(minValue);
    const max = parsePositiveNumber(maxValue);

    if (min > 0 && max > 0) {
        if (min === max) return formatCurrency(min);
        return `${formatCurrency(min)} à ${formatCurrency(max)}`;
    }
    if (min > 0) return `a partir de ${formatCurrency(min)}`;
    if (max > 0) return `até ${formatCurrency(max)}`;
    return '';
};

const formatAreaRange = (areaMin: any, areaMinAlt: any, areaMax: any) => {
    const min = parseAreaValue(areaMin) || parseAreaValue(areaMinAlt);
    const max = parseAreaValue(areaMax);

    if (min > 0 && max > 0) {
        if (min === max) return `${formatAreaNumber(min)} m²`;
        return `${formatAreaNumber(min)} à ${formatAreaNumber(max)} m²`;
    }
    if (min > 0) return `a partir de ${formatAreaNumber(min)} m²`;
    if (max > 0) return `até ${formatAreaNumber(max)} m²`;
    return '';
};

const formatQtdRange = (minValue: any, maxValue: any, singular: string, plural: string, fallback?: any) => {
    const min = parsePositiveNumber(minValue);
    const max = parsePositiveNumber(maxValue);
    const fallbackValue = parsePositiveNumber(fallback);

    if (min > 0 && max > 0) {
        if (min === max) return `${formatAreaNumber(min)} ${min === 1 ? singular : plural}`;
        return `${formatAreaNumber(min)} à ${formatAreaNumber(max)} ${plural}`;
    }
    if (max > 0) return `até ${formatAreaNumber(max)} ${plural}`;
    if (min > 0) return `a partir de ${formatAreaNumber(min)} ${plural}`;
    if (fallbackValue > 0) return `${formatAreaNumber(fallbackValue)} ${fallbackValue === 1 ? singular : plural}`;
    return '';
};

const formatSituacao = (value: string | null | undefined) => {
    const key = String(value || '').toLowerCase();
    const map: Record<string, string> = {
        emconstrucao: 'Em construção',
        lancamento: 'Lançamento',
        pronto: 'Pronto para morar'
    };
    return map[key] || String(value || 'Disponível');
};

const getFotoUrlFromFotos = (fotos: any) => {
    if (!fotos) return '';

    if (typeof fotos === 'string') {
        return fotos;
    }

    const list = Array.isArray(fotos)
        ? fotos
        : typeof fotos === 'object'
            ? Object.values(fotos)
            : [];

    const first = list.find((item: any) => {
        if (!item) return false;
        if (typeof item === 'string') return Boolean(item);
        return Boolean(item?.url_foto || item?.url_spaces_cdn || item?.url_spaces_migracao || item?.url_marca);
    });

    if (!first) return '';
    if (typeof first === 'string') return first;
    return first?.url_foto || first?.url_spaces_cdn || first?.url_spaces_migracao || first?.url_marca || '';
};

const ListPiecesProperties: React.FC<{
    allProperties: Array<any>;
    setAllProperties?: any;
    allPropertiesMapa: Array<any>;
    site: any;
    page: any;
    setPage: any;
    searchList: any;
    qtd: number;
    typeValidation: any;
    first: any;
    typeActual?: any;
    setTypeActual?: any;
    districtActual?: any;
    setDistrictActual?: any;
    cityActual?: any;
    filtersInitialized?: any;
    setCityActual?: any;
    codeActual?: any;
    setCodeActual?: any;
    companyActual?: any;
    setCompanyActual?: any;
    orderActual?: any;
    setOrderActual?: any;
    price?: any;
    setPrice?: any;
    filterPrice?: any;
    setFilterPrice?: any;
    listCity?: any;
    allCities: Array<{label: string, value: number,id_estado: any}>;
    setListCity?: any;
    listType?: any;
    listCompany?: any;
    listDistrict?: any;
    setListDistrict?: any;
    type?: any;
    setType?: any;
    filters?: any;
    setAutorizaBusca?: any;
    setFilters?: any;
    applyFilter?: any;
    activeLargeFilter?: any;
    setActiveLargeFilter?: any;
    companyInputActual?: any;
    setCompanyInputActual?: any;
    loading?: any;
    setLoading?: any;
    renderTextFilters?: any;
    agenciador?: Number;
    setAgenciador?: any;
    favorito: any;
    setFavorito: any;
    openFavoritos: boolean;
    setOpenFavoritos?: any;
    naoEncontrou?: boolean;
    zeraFiltros?: () => void;
    allUrl?: any;
    origin?: any;
    codsite?: any;
    codsite2?: any;
    valores?: any;
    listCategory?: any;
    listCaract?: any;
    caractActual?: any;
    setCaractActual?: any;
    categoryActual?: any;
    setCategoryActual?: any;
    listEstados?: any;
    setEstadoActual?: any;
    estadoActual: any;
    listDatas?: any;
    dataEntregaActual?: any;
    setDataEntregaActual?: any;
    area: any;
    setArea: any;
    allViewProperties: any;
    disableEntryMotion?: boolean;
}> = ({
    listDatas,
    dataEntregaActual,
    setDataEntregaActual,
    allProperties,
    allPropertiesMapa,
    setAllProperties,
    site,
    first,
    page,
    setPage,
    setAutorizaBusca,
    searchList: _searchList,
    qtd,
    filtersInitialized: _filtersInitialized,
    setArea,
    area,
    typeValidation,
    typeActual,
    setTypeActual,
    districtActual,
    setDistrictActual,
    cityActual,
    setCityActual,
    codeActual,
    setCodeActual,
    companyActual,
    setCompanyActual,
    orderActual,
    setOrderActual,
    price,
    setPrice,
    filterPrice,
    setFilterPrice,
    listCity,
    setListCity,
    allCities,
    listType,
    listCompany,
    listDistrict,
    setListDistrict,
    type,
    setType,
    filters,
    setFilters,
    applyFilter,
    activeLargeFilter,
    setActiveLargeFilter,
    companyInputActual,
    setCompanyInputActual,
    loading,
    setLoading,
    renderTextFilters,
    agenciador,
    setAgenciador,
    favorito,
    setFavorito,
    openFavoritos,
    setOpenFavoritos,
    naoEncontrou,
    zeraFiltros,
    allUrl: _allUrl,
    origin,
    codsite,
    valores,
    codsite2,
    listCategory,
    listCaract,
    caractActual,
    setCaractActual,
    categoryActual,
    setCategoryActual,
    listEstados,
    setEstadoActual,
    estadoActual,
    allViewProperties,
    disableEntryMotion
}) => {
    // constants
    const corLetra1 = isColorLight(site?.cor2) ? site?.cor11 : site?.cor2;
    const corLetra2 = isColorLight(site?.cor5) ? site?.cor11 : site?.cor13;

    const corFundo = "#FFFFFF";
    const colorPicker = customSelectPropertiesStyles(corLetra1,corFundo,site?.cor2,corLetra1);
    const colorPicker1 = customSelectPropertiesStyles(corLetra2,site?.cor5,site?.cor2,corLetra2,true);
    const colorPickerCompany = customSelectPropertiesStyles(corLetra1,corFundo,site?.cor2,corLetra1);
    const orderSelectStyles = useMemo(
        () => ({
            ...colorPicker1,
            menu: (base: any) => {
                const themedMenu = colorPicker1?.menu ? colorPicker1.menu(base) : base;
                return {
                    ...themedMenu,
                    zIndex: 20000,
                    pointerEvents: 'auto'
                };
            },
            menuPortal: (base: any) => ({
                ...base,
                zIndex: 20000,
                pointerEvents: 'auto'
            })
        }),
        [colorPicker1]
    );
    const orderSelectPortalTarget =
        typeof window !== 'undefined' ? document.body : undefined;
    const [codeInput, setCodeInput] = useState(codeActual || "");
    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
        setLoading(true);
        setAutorizaBusca(true);
        window.scroll({top:300, behavior: "smooth"})
    };
    const marginIconTag = { marginTop: 3 };
    const minDistance = 1000;
    const size = useWindowSize();
    const stylesIconClose = corLetra1;
    const stylesIconClose1 = corLetra2;
    const stylesTags = {
        color: corLetra2,
        border: `2px solid ${corLetra2}`,
    };
    const stylesTags2 = {
        color: corLetra1,
        border: `2px solid ${corLetra1}`,
    };
    const motionBase = disableEntryMotion
        ? { initial: false, animate: { opacity: 1, y: 0 }, transition: { duration: 0 } }
        : { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 } };
    const initializeSquareCardsLayout = String(site?.id) === '2474';
    const isSite2507 = String(site?.id) === '2507';
    const formatSelectedCount = (
        items: Array<any>,
        singular: string,
        plural: string
    ) => {
        const count = items?.length || 0;
        if (count === 0) return '';
        return `${count} ${count === 1 ? singular : plural} selecionado${count === 1 ? '' : 's'}`;
    };
    // const router = useRouter();
    // const { pagination } = router.query;
    // useState
    const [imput_price, setImput_price] = useState<any>(price);
    const [managerActual, setManagerActual] = useState<any>(null);
    const [lastType, setLastType] = useState<any>(type);
    const [mapaOn, setMapaOn] = useState<any>(0);
    const [positionCard, setPositionCard] = useState<any>(
        site?.modelo_card > 1 && !isMobile && !initializeSquareCardsLayout ? 1 : 0
    );
    const isHorizontalCardLayout = Boolean(positionCard);
    const [status, setStatus] = useState('');
    const [areaAux,setAreaAux] = useState(area)
    const [empreendimentoDetalhe, setEmpreendimentoDetalhe] = useState<any>(null);
    const [empreendimentoDetalheLoading, setEmpreendimentoDetalheLoading] = useState(false);
    const [orderMenuOpen, setOrderMenuOpen] = useState(false);
    const [orderMenuInteractionLocked, setOrderMenuInteractionLocked] = useState(false);
    const orderSelectRef = useRef<any>(null);
    const orderMenuUnlockTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const clearOrderMenuUnlockTimeout = () => {
        if (orderMenuUnlockTimeoutRef.current) {
            clearTimeout(orderMenuUnlockTimeoutRef.current);
            orderMenuUnlockTimeoutRef.current = null;
        }
    };

    const closeOrderMenu = () => {
        clearOrderMenuUnlockTimeout();
        setOrderMenuOpen(false);
        setOrderMenuInteractionLocked(false);
        orderSelectRef.current?.blur?.();
    };

    const handleOrderMenuOpen = () => {
        if (activeLargeFilter) {
            closeOrderMenu();
            return;
        }

        clearOrderMenuUnlockTimeout();
        setOrderMenuOpen(true);
        setOrderMenuInteractionLocked(true);
    };

    const handleOrderMenuClose = () => {
        setOrderMenuOpen(false);
        clearOrderMenuUnlockTimeout();
        orderMenuUnlockTimeoutRef.current = setTimeout(() => {
            setOrderMenuInteractionLocked(false);
            orderMenuUnlockTimeoutRef.current = null;
        }, 220);
    };

    const getComparablePrice = (item: any) => {
        const precoEspecialVenda = Number(item?.preco_especial?.preco_especial_venda) || 0;
        const precoEspecialLocacao = Number(item?.preco_especial?.preco_especial_locacao) || 0;
        const precoVenda = Number(item?.preco_venda) || 0;
        const precoLocacao = Number(item?.preco_locacao) || 0;

        if (type === 'rent') {
            return precoEspecialLocacao || precoLocacao || precoEspecialVenda || precoVenda || 0;
        }

        return precoEspecialVenda || precoVenda || precoEspecialLocacao || precoLocacao || 0;
    };

    const sortFavoritosList = (list: Array<any>) => {
        const favoritesOnly = (list || []).filter((item: any) => favorito?.indexOf(item?.id) !== -1);

        if (!orderActual?.value) {
            return favoritesOnly;
        }

        const [direction, criteria] = String(orderActual.value).split('-');
        const isDesc = direction === 'desc';

        const compareByDate = (a: any, b: any) => {
            const aDate = new Date(a?.data_edicao || 0).getTime() || Number(a?.id) || 0;
            const bDate = new Date(b?.data_edicao || 0).getTime() || Number(b?.id) || 0;
            return isDesc ? bDate - aDate : aDate - bDate;
        };

        const compareByValor = (a: any, b: any) => {
            const diff = getComparablePrice(a) - getComparablePrice(b);
            return isDesc ? -diff : diff;
        };

        const compareByViews = (a: any, b: any) => {
            const diff = (Number(a?.visualizacoes) || 0) - (Number(b?.visualizacoes) || 0);
            return isDesc ? -diff : diff;
        };

        switch (criteria) {
            case 'inclusao':
                return favoritesOnly.slice().sort(compareByDate);
            case 'valor':
                return favoritesOnly.slice().sort(compareByValor);
            case 'visualizacao':
                return favoritesOnly.slice().sort(compareByViews);
            default:
                return favoritesOnly;
        }
    };

    useEffect(() => {
        return () => {
            clearOrderMenuUnlockTimeout();
        };
    }, []);

    useEffect(() => {
        const empreendimentoId = Number(companyActual?.value || 0);
        const exibeEmpreendimento = Boolean(site?.exibir_empreendimento);

        if (!exibeEmpreendimento || !empreendimentoId) {
            setEmpreendimentoDetalhe(null);
            setEmpreendimentoDetalheLoading(false);
            return;
        }

        let isActive = true;
        setEmpreendimentoDetalheLoading(true);

        getEmpreendimentoById(empreendimentoId, origin, codsite)
            .then((response: any) => {
                if (!isActive) return;
                const empreendimentoResponse = response?.empreendimento || null;
                setEmpreendimentoDetalhe(
                    empreendimentoResponse && isEmpreendimentoVisibleOnSite(empreendimentoResponse?.mostrar_site)
                        ? empreendimentoResponse
                        : null
                );
            })
            .catch(() => {
                if (!isActive) return;
                setEmpreendimentoDetalhe(null);
            })
            .finally(() => {
                if (!isActive) return;
                setEmpreendimentoDetalheLoading(false);
            });

        return () => {
            isActive = false;
        };
    }, [codsite, companyActual?.value, origin, site?.exibir_empreendimento]);

    const empreendimentoResumo = useMemo(() => {
        if (
            !site?.exibir_empreendimento ||
            !Number(companyActual?.value || 0) ||
            !empreendimentoDetalhe?.id ||
            !isEmpreendimentoVisibleOnSite(empreendimentoDetalhe?.mostrar_site)
        ) {
            return null;
        }

        const empreendimento = empreendimentoDetalhe;
        const href = empreendimento?.id ? `/empreendimento/${empreendimento.id}` : '';
        if (!href) {
            return null;
        }

        const cidadeUf = [empreendimento?.cidade, empreendimento?.uf].filter(Boolean).join(' - ');
        const localizacao = [empreendimento?.endereco, empreendimento?.bairro, cidadeUf].filter(Boolean).join(', ');
        const categoria = String(empreendimento?.categoria_empreendimento?.nome || '').trim();
        const caracteristicas = extractEmpreendimentoCaracteristicas(empreendimento);
        const faixaPreco = formatPriceRange(empreendimento?.preco_min, empreendimento?.preco_max);
        const faixaArea = formatAreaRange(
            empreendimento?.area_privativa_min,
            empreendimento?.are_privativa_min,
            empreendimento?.area_privativa_max
        );

        const dormitoriosLabel = formatQtdRange(
            empreendimento?.dormitorios_min,
            empreendimento?.dormitorios_max,
            'dorm',
            'dorms',
            empreendimento?.dormitorios || empreendimento?.suites
        );
        const banheirosLabel = formatQtdRange(
            empreendimento?.banheiros_min,
            empreendimento?.banheiros_max,
            'banheiro',
            'Banheiros',
            empreendimento?.banheiros
        );
        const vagasLabel = formatQtdRange(
            empreendimento?.vagas_min,
            empreendimento?.vagas_max,
            'vaga',
            'Vagas',
            empreendimento?.vagas
        );

        const fotosOrdenadas = Array.isArray(empreendimento?.fotos)
            ? [...empreendimento.fotos].sort((a: any, b: any) => Number(a?.posicao || 0) - Number(b?.posicao || 0))
            : [];
        const fotoDestaque = fotosOrdenadas.find((item: any) => Number(item?.destaque) === 1)?.url_foto;
        const foto = fotoDestaque || getFotoUrlFromFotos(fotosOrdenadas) || fallbackEmpreendimentoImage;
        const highlights = [
            { key: 'dormitorios', icon: 'dormitorios', label: dormitoriosLabel },
            { key: 'area', icon: 'area', label: faixaArea },
            { key: 'banheiros', icon: 'banheiros', label: banheirosLabel },
            { key: 'vagas', icon: 'vagas', label: vagasLabel }
        ].filter((item) => Boolean(item.label));

        return {
            nome: empreendimento?.nome || companyActual?.label || 'Empreendimento',
            href,
            categoria,
            caracteristicas,
            localizacao,
            faixaPreco,
            faixaArea,
            situacao: formatSituacao(empreendimento?.situacao),
            highlights,
            foto
        };
    }, [companyActual?.label, companyActual?.value, empreendimentoDetalhe, site?.exibir_empreendimento]);

    const onChangeOrder = (txt: any) => {
        setOrderActual(txt);
        closeOrderMenu();
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeType = () => {
        if (type === 'sale') {
            if(site?.transacoes[1] == 'Temporada'){
                setType('temporada')
            } else {
                setType('rent');
            }
        }
        if (type === 'rent') {
            if(site?.transacoes[1] == 'Temporada'){
                setType('temporada')
            } else {
                setType('sale');
            }
        }
        if (type === 'temporada') {
            if(site?.transacoes[0] == 'Venda'){
                setType('sale')
            } else {
                setType('rent');
            }
        }
    };

    const onChangeCategory = async (txt: any) => {
        setCategoryActual(txt.value ? txt : 0);
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeDatas = (txt: any) => {
        if (!Number(txt.value)) {
            setDataEntregaActual([]);
        } else {
            const existId = dataEntregaActual?.filter(
                (v: any) => v.value === txt.value
            );
            setDataEntregaActual(
                existId.length > 0 ? dataEntregaActual : [...dataEntregaActual, txt]
            );
        }
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeCaracteristicas = (txt: any) => {
        if (!Number(txt.value)) {
            setCaractActual([]);
        } else {
            const existId = caractActual?.filter(
                (v: any) => v.value === txt.value
            );
            setCaractActual(
                existId.length > 0 ? caractActual : [...caractActual, txt]
            );
        }
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeCity = async (txt: any) => {
        setCityActual(txt.value ? txt : null);
        if (txt.value) {
            setDistrictActual([]);
            const infoDistrict = await district(txt.value, origin, codsite);
            const existValueDefault = listDistrict?.filter(
                (v: any) => !v.value
            );
            if (!existValueDefault.length) {
                setListDistrict(formatSelects(infoDistrict?.bairros));
            } else {
                setListDistrict(formatSelects(infoDistrict?.bairros));
            }
        }
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeEstados = async (txt: any) => {
        setEstadoActual(txt.value ? txt : 0);

        const cidadesFiltradas = allCities.filter(
            city => city?.id_estado === txt.value
        );

        setDistrictActual([]);
        setListDistrict([]);
        setCityActual(null);
        setListCity(cidadesFiltradas);
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeDistrict = (txt: any) => {
        if (Array.isArray(txt)) {
            const hasInvalid = txt.some((opt) => !Number(opt?.value));
            if (hasInvalid) {
                setDistrictActual([]);
            } else {
                setDistrictActual(txt);
            }
            setPage(1);
            setAutorizaBusca(true);
            return;
        }
        if (!Number(txt?.value)) {
            setDistrictActual([]);
        } else {
            const existId = districtActual?.filter(
                (v: any) => v.value === txt.value
            );
            setDistrictActual(
                existId.length > 0 ? districtActual : [...districtActual, txt]
            );
        }
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeTypes = (txt: any) => {
        if (Array.isArray(txt)) {
            const hasInvalid = txt.some((opt) => !Number(opt?.value));
            if (hasInvalid) {
                setTypeActual([]);
            } else {
                setTypeActual(txt);
            }
            setPage(1);
            setAutorizaBusca(true);
            return;
        }
        if (!Number(txt?.value)) {
            setTypeActual([]);
        } else {
            const existId = typeActual?.filter(
                (v: any) => v.value === txt.value
            );
            setTypeActual(
                existId.length > 0 ? typeActual : [...typeActual, txt]
            );
        }
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeCompany = (txt: any) => {
        setCompanyActual(txt.value ? txt : 0);
        setPage(1);
        setAutorizaBusca(true);
    };

    const onChangeCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCodeInput(e.target.value);
    };

    useEffect(() => {
        if(codeInput){
            const handler = setTimeout(() => {
                setCodeActual(codeInput);
                setPage(1);
                setAutorizaBusca(true);
            }, 2000);

            return () => clearTimeout(handler); // limpa timeout se digitar de novo
        }

    }, [codeInput]);

    const onChangeMinimo = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = Number(e.target.value.replace(/\D/g, ''));  // só números

        // a) atualiza UI instantaneamente
        setImput_price([val, imput_price[1]]);

        // b) reinicia debounce
        if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
            if (val >= 0 && val < price[1]) {
                setPrice([val, price[1]]);            // ← só depois de 1 s
                setPage(1);
                setAutorizaBusca(true);
            } else {
                setPrice([val, val]);  
                setImput_price([val, val]);
                setPage(1);
                setAutorizaBusca(true);
            }
            timerRef.current = null;
        }, DEBOUNCE_MS);
    };

    const onChangeMaximo = (e: React.ChangeEvent<HTMLInputElement>) => {
        // remove qualquer caractere não numérico
        const val = Number(e.target.value.replace(/\D/g, ''));

        setImput_price([imput_price[0], val]);

        // 2) reinicia o debounce para o estado global
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            if (val >= 0 && val < price[0]) {
                setPrice([val, val]);  
                setImput_price([val, val]);   
                setPage(1);  
                setAutorizaBusca(true);      
            } else {
                setPrice([imput_price[0], val]); 
                setPage(1);
                setAutorizaBusca(true);
            }
            timerRef.current = null;
        }, DEBOUNCE_MS);
    };

    const onChangeAreaMinimo = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const value: number = Number(txt.target.value);
        setAreaAux([value,areaAux[1]])
        if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                if(value>=0 && value<=areaAux[1]){
                    setArea([value,areaAux[1]])
                    setAreaAux([value,areaAux[1]])
                    setPage(1);
                    setAutorizaBusca(true);
                } else {
                    if(value>=0){
                        setArea([value,value])
                        setAreaAux([value,value])
                        setPage(1);
                        setAutorizaBusca(true);
                    }
                 }
                timerRef.current = null;
        }, DEBOUNCE_MS);
    };

    const onChangeAreaMaximo = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const value: number = Number(txt.target.value);
        setAreaAux([areaAux[0],value])
        if (timerRef.current) clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                 if(value>=0 && value >= areaAux[0]){
                    setArea([areaAux[0],value])
                    setAreaAux([areaAux[0],value])
                    setPage(1);
                    setAutorizaBusca(true);
                } else {
                    if(value>=0){
                        setArea([0,value])
                        setAreaAux([0,value])
                        setPage(1);
                        setAutorizaBusca(true);
                    }
                }
            timerRef.current = null;
        }, DEBOUNCE_MS);
    };

    const onInputChangeCompany = (txt: any) => {
        setCompanyInputActual(txt);
    };

    const limpaFavoritos = () => {
        window.localStorage.removeItem('favoritos');
        setFavorito([])
        setOpenFavoritos(false)
        setPage(1);
        setAutorizaBusca(true);
    };

    // 3️⃣ ref para guardar o timer
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    /* ---------- handlers ---------- */

    // muda só a UI (movimento fluido) e respeita o minDistance
    // refs de controle
    const isUserSlidingRef = useRef(false);     // verdadeiro apenas durante interação do usuário no slider
    const suppressCommitRef = useRef(false);    // verdadeiro quando vamos atualizar preço programaticamente

    // NOVOS refs
    const commitSeqRef = useRef(0);             // token p/ invalidar timeouts antigos

    // helper p/ cancelar qualquer commit/timeout pendente
    const cancelPendingPriceCommit = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = null;
        isUserSlidingRef.current = false;
        commitSeqRef.current++; // invalida timeouts já agendados
    };

   const handleChangePrice = (
    _: Event | React.SyntheticEvent<Element, Event>,
    newValue: number | number[],
    activeThumb: number,
    ) => {
        if (!Array.isArray(newValue)) return;

        // interação do usuário começou
        isUserSlidingRef.current = true;

        let next = newValue;
        if (next[1] - next[0] < minDistance) {
            if (activeThumb === 0) {
            next = [Math.min(next[0], filterPrice.max - minDistance), next[0] + minDistance];
            } else {
            next = [next[1] - minDistance, Math.max(next[1], filterPrice.min + minDistance)];
            }
        }
        setImput_price(next);
    };

    useEffect(() => () => cancelPendingPriceCommit(), []);

    useEffect(() => {
        if (!Array.isArray(price) || isUserSlidingRef.current) return;

        const nextPrice: [number, number] = [
            Number(price[0] || 0),
            Number(price[1] || 0)
        ];
        const currentPrice = Array.isArray(imput_price) ? imput_price : [];
        if (currentPrice[0] !== nextPrice[0] || currentPrice[1] !== nextPrice[1]) {
            setImput_price(nextPrice);
        }
    }, [price]);

    const handleCommitted = (
        _: Event | React.SyntheticEvent<Element, Event>,
        newValue: number | number[],
    ) => {
        // ignora se foi update programático ou sem interação real
        if (suppressCommitRef.current || !isUserSlidingRef.current || !Array.isArray(newValue)) return;

        isUserSlidingRef.current = false;

        // gera token para este commit
        const mySeq = ++commitSeqRef.current;

        // reinicia debounce
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            // se outro evento invalidou este commit, sai
            if (mySeq !== commitSeqRef.current) return;

            setPrice(newValue);
            setPage(1);
            setAutorizaBusca(true);
            timerRef.current = null;
        }, DEBOUNCE_MS);
    };

    const GetFilterPrice = async () => {
        let getFilter = valores;
        const newFilter = () => {
            if (type === 'rent') return getFilter?.precos_locacao[0];
            if (type === 'sale') return getFilter?.precos_venda[0];
            if (type === 'temporada') {
            if (getFilter?.precos_locacao[0]?.max)
                return { min: 0, max: getFilter?.precos_locacao[0]?.max };
            return { min: 0, max: getFilter?.precos_venda[0]?.max };
            }
            return null;
        };

        const getFiltersPrices = await newFilter();

        if (filterPrice?.min !== getFiltersPrices?.min || filterPrice?.max !== getFiltersPrices?.max) {
            setFilterPrice(!getFiltersPrices?.min && !getFiltersPrices?.max ? { min: 0, max: 0 } : getFiltersPrices);
        }

        const hasInvalidPrice =
            !Array.isArray(price) ||
            price[0] === undefined ||
            price[1] === undefined ||
            Number(price[0]) > Number(price[1]) ||
            Number(price[0]) < getFiltersPrices?.min ||
            Number(price[1]) > getFiltersPrices?.max ||
            (Number(price[0]) === 0 && Number(price[1]) === 0 && Number(getFiltersPrices?.max) > 0);

        const typeChanged = type != lastType;

        if (typeChanged && getFiltersPrices) {
            setLastType(type)
            suppressCommitRef.current = true;

            setImput_price([getFiltersPrices.min, getFiltersPrices.max]);
            setPrice([getFiltersPrices.min, getFiltersPrices.max]);
            setPage(1);
            setAutorizaBusca(true);

            setTimeout(() => { suppressCommitRef.current = false; }, 0);
            return;
        }

        if (hasInvalidPrice && getFiltersPrices) {
            suppressCommitRef.current = true;
            
            setImput_price([getFiltersPrices.min, getFiltersPrices.max]);
            setPrice([getFiltersPrices.min, getFiltersPrices.max]);
            setPage(1);
            setAutorizaBusca(true);

            // libera no próximo tick
            setTimeout(() => { suppressCommitRef.current = false; }, 0);
        }
    };

    const GetAgenciadorId = async () => {
        if (agenciador && agenciador != undefined ) {
            const GetManager = await getManagerId(Number(agenciador), origin, codsite);
            if(GetManager?.parceiros?.length > 0){
                setManagerActual(GetManager?.parceiros[0]);
                setStatus('valid');
            }
        }
    }

    const openFilter = () => {
        closeOrderMenu();
        setActiveLargeFilter(true);
    };

    useEffect(() => {
        if (!openFavoritos) return;
        if (!setAllProperties) return;

        if(favorito?.length == 0 && !loading){
            limpaFavoritos();
            return;
        }

        const sortedFavorites = sortFavoritosList(allProperties || []);

        const sameOrder =
            sortedFavorites.length === (allProperties?.length || 0) &&
            sortedFavorites.every((item: any, index: number) => item?.id === allProperties?.[index]?.id);

        if (!sameOrder) {
            setAllProperties(sortedFavorites);
        }
    }, [allProperties, favorito, openFavoritos, orderActual, loading]);

    useEffect(() => {
        cancelPendingPriceCommit();
        if (typeValidation && first) {
            GetFilterPrice();
        }
    }, [type, typeValidation]);

    useEffect(() => {
        if (size?.width > 900 && typeValidation) {
            setActiveLargeFilter(false);
        }
    }, [size?.width]);

    useEffect(() => {
        if (!activeLargeFilter) return;
        closeOrderMenu();
    }, [activeLargeFilter]);

    useEffect(() => {
        GetAgenciadorId();
    }, [agenciador]);

    const renderFilters = () => {
        return (
            <>
                {typeValidation ? (
                    <motion.div
                        key="topo"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.1 }}
                        className={styles.container_filter}
                        data-nosnippet
                        style={{background: corFundo,border: `1px solid ${hexToRgba(corLetra1,0.5)}`}}
                    >
                        <div className={styles.adjust_header_tabs}>
                            { site?.transacoes?.length > 1 ?
                                <>
                                    <button
                                        aria-label="Botão para buscar imóveis de venda"
                                        title="Clique aqui para buscar imóveis para venda"
                                        type="button"
                                        className={
                                            type === 'sale'
                                                ? styles.header_tab_focus
                                                : styles.header_tab
                                        }
                                        style={type === 'sale' ? {background: site?.cor2,color: isColorLight(site?.cor2) ? site?.cor11 : site?.cor13} : {background: "none",color: corLetra1}}
                                        onClick={() => setType('sale')}
                                    >
                                        Comprar
                                    </button>
                                    { site?.transacoes[1] == 'Temporada' ?
                                        <button
                                            aria-label="Botão para buscar imóveis de temporada"
                                            title="Clique aqui para buscar imóveis para temporada"
                                            type="button"
                                            className={
                                                type === 'temporada'
                                                    ? styles.header_tab_focus
                                                    : styles.header_tab
                                            }
                                            style={type === 'temporada' ? {background: site?.cor2,color: isColorLight(site?.cor2) ? site?.cor11 : site?.cor13} : {background: "none",color: corLetra1}}
                                            onClick={() => setType('temporada')}
                                            >
                                            Temporada
                                        </button>
                                    :
                                        <button
                                            aria-label="Botão para buscar imóveis de aluguel"
                                            title="Clique aqui para buscar imóveis para alugar"
                                            type="button"
                                            className={
                                                type === 'rent'
                                                    ? styles.header_tab_focus
                                                    : styles.header_tab
                                            }
                                            style={type === 'rent' ? {background: site?.cor2,color: isColorLight(site?.cor2) ? site?.cor11 : site?.cor13} : {background: "none",color: corLetra1}}
                                            onClick={() => setType('rent')}
                                        >
                                            Alugar
                                        </button>
                                    }
                                </>
                            : null }
                            { site?.transacoes?.length > 2 ?
                                <button
                                    aria-label="Botão para buscar imóveis para temporada"
                                    title="Clique aqui para buscar imóveis de temporada"
                                    type="button"
                                    style={type === 'temporada' ? {background: site?.cor2,color: isColorLight(site?.cor2) ? site?.cor11 : site?.cor13} : {background: "none",color: corLetra1}}
                                    className={
                                        type === 'temporada'
                                            ? styles.header_tab_focus
                                            : styles.header_tab
                                    }
                                    onClick={() => setType('temporada')}
                                >
                                    Temporada
                                </button> : null
                            }
                        </div>
                        <div className={styles.adjust_slider}>
                            {<div className={styles.adjust_select_price}>
                                    <label className={styles.title_select} style={{color: corLetra1}}>
                                        PREÇOS
                                    </label>
                                    <div className={styles.adjust_prices}>
                                        <label className={styles.price} style={{color: corLetra1}}>
                                            {`${site?.moeda_tipo} ${toPrice(imput_price[0] ||
                                                Number(
                                                    Number(
                                                        (filterPrice?.max) *
                                                            ((imput_price?.length > 0
                                                                ? imput_price[0]
                                                                : 0) /
                                                                100)
                                                    )
                                                ),
                                                2
                                            )}`}
                                        </label>
                                        <label className={styles.price} style={{color: corLetra1}}>
                                            {`${site?.moeda_tipo} ${toPrice(imput_price[1] ||
                                                Number(
                                                    Number(
                                                        (filterPrice?.max) *
                                                            ((imput_price?.length > 0
                                                                ? imput_price[1]
                                                                : 0) /
                                                                100)
                                                    )
                                                ),
                                                2
                                            )}`}
                                        </label>
                                    </div>

                                    <Slider
                                        value={imput_price || [0,100]}
                                        onChange={handleChangePrice}
                                        onChangeCommitted={handleCommitted}
                                        disableSwap
                                        min={filterPrice?.min}
                                        max={filterPrice?.max}
                                        step={1000}
                                        style={{
                                            color: isColorLight(site?.cor5) ? isColorLight(site?.cor2) ? corLetra1 : site?.cor2 : corLetra1,
                                        }}
                                    />
                                </div>
                            }
                        </div>
                        <div className={styles.adjust_select_p}>
                            <div className={styles.adjust_select_price1} style={{margin: "0px 2.5% 0px 0px"}}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    MÍNIMO
                                </label>
                                <input
                                    className={styles.input}
                                    placeholder={imput_price ? "R$ "+imput_price[0] : "Valor mínimo"}
                                    onChange={onChangeMinimo}
                                    inputMode='numeric'
                                    value={imput_price[0]}
                                    style={{ color: corLetra1,border: `2px solid ${corLetra1}` }}
                                />
                            </div>
                            <div className={styles.adjust_select_price1} style={{margin: "0px 0px 0px 2.5%"}}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    MÁXIMO
                                </label>
                                <input
                                    className={styles.input}
                                    placeholder={imput_price ? "R$ "+imput_price[1] : "Valor Máximo"}
                                    onChange={onChangeMaximo}
                                    inputMode='numeric'
                                    value={imput_price[1]}
                                    style={{ color: corLetra1,border: `2px solid ${corLetra1}` }}
                                />
                            </div>
                        </div>
                        {(site?.id == 2177 || site?.id == 2297 || site?.id == 1942 || site?.id == 2065) && listEstados ?
                        <div className={styles.adjust_select}>
                            <label className={styles.title_select} style={{color: corLetra1}}>
                                ESTADO
                            </label>
                            <Select
                                options={listEstados}
                                className={styles.select}
                                placeholder="Estado"
                                noOptionsMessage={() => 'Estado não encontrado!'}
                                styles={colorPicker}
                                value={estadoActual}
                                onChange={onChangeEstados}
                                instanceId={0}
                            />
                        </div> : null}
                        {estadoActual && (site?.id == 2177 || site?.id == 2297 || site?.id == 1942 || site?.id == 2065) ? (
                            <div className={styles.adjust_tags_filter}>
                                <button
                                    aria-label={`Botão para remover filtro de estado ${estadoActual?.label}`}
                                    title={`Clique para remover filtro de estado ${estadoActual?.label}`}
                                    type="button"
                                    className={styles.tags_picker}
                                    onClick={() => {
                                        setDistrictActual([]);
                                        setListDistrict([]);
                                        setCityActual(null);
                                        setListCity(allCities);
                                        setEstadoActual(null);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    }}
                                    style={stylesTags2}
                                >
                                    {estadoActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose}
                                        style={marginIconTag}
                                    />
                                </button>
                            </div>
                        ) : null}
                        <div className={styles.adjust_select}>
                            <label className={styles.title_select} style={{color: corLetra1}}>
                                CIDADES
                            </label>
                            <Select
                                options={listCity}
                                className={styles.select}
                                placeholder="Cidades"
                                noOptionsMessage={() => 'Cidade não encontrada!'}
                                styles={colorPicker}
                                value={cityActual}
                                onChange={onChangeCity}
                                instanceId={0}
                            />
                        </div>
                        {cityActual ? (
                            <div className={styles.adjust_tags_filter}>
                                <button
                                    aria-label={`Botão para remover filtro da cidade ${cityActual?.label}`}
                                    title={`Clique para remover filtro da cidade ${cityActual?.label}`}
                                    type="button"
                                    className={styles.tags_picker}
                                    onClick={() => {
                                        setDistrictActual([]);
                                        setListDistrict([]);
                                        setCityActual(null);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    }}
                                    style={stylesTags2}
                                >
                                    {cityActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose}
                                        style={marginIconTag}
                                    />
                                </button>
                            </div>
                        ) : null}
                        <div className={styles.adjust_select}>
                            <label className={styles.title_select} style={{color: corLetra1}}>
                                BAIRROS
                            </label>
                            <Select
                                options={listDistrict}
                                className={styles.select}
                                placeholder={
                                    formatSelectedCount(districtActual, 'bairro', 'bairros') || 'Bairros'
                                }
                                noOptionsMessage={() => 'Bairro não encontrado!'}
                                styles={colorPicker}
                                isMulti
                                closeMenuOnSelect
                                controlShouldRenderValue={false}
                                hideSelectedOptions={false}
                                isClearable={false}
                                components={{ ClearIndicator: null }}
                                value={districtActual}
                                onChange={onChangeDistrict}
                                instanceId={1}
                            />
                        </div>
                        {districtActual?.length > 0 ? (
                            <div className={styles.adjust_tags_filter}>
                                {districtActual?.map((v: any) => {
                                    const removeDistrict = () => {
                                        const removeUnique =
                                            districtActual?.filter(
                                                (e: any) =>
                                                    e?.value !== v?.value
                                            );
                                        setDistrictActual(removeUnique);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    };
                                    return (
                                        <button
                                            aria-label={`Botão para remover filtro do bairro ${v?.label}`}
                                            title={`Clique para remover filtro do bairro ${v?.label}`}
                                            type="button"
                                            className={styles.tags_picker}
                                            onClick={removeDistrict}
                                            key={v?.value}
                                            style={stylesTags2}
                                        >
                                            {v?.label}
                                            <IoCloseSharp
                                                size={16}
                                                color={stylesIconClose}
                                                style={marginIconTag}
                                            />
                                        </button>
                                    );
                                })}
                            </div>
                        ) : null}
                        <div className={styles.adjust_select}>
                            <label className={styles.title_select} style={{color: corLetra1}}>TIPOS</label>
                            <Select
                                options={listType}
                                className={styles.select}
                                placeholder={
                                    formatSelectedCount(typeActual, 'tipo', 'tipos') || 'Tipos'
                                }
                                noOptionsMessage={() => 'Tipo não encontrado!'}
                                styles={colorPicker}
                                isMulti
                                closeMenuOnSelect
                                controlShouldRenderValue={false}
                                hideSelectedOptions={false}
                                isClearable={false}
                                components={{ ClearIndicator: null }}
                                value={typeActual}
                                onChange={onChangeTypes}
                                instanceId={2}
                            />
                        </div>
                        {typeActual?.length > 0 ? (
                            <div className={styles.adjust_tags_filter}>
                                {typeActual?.map((v: any) => {
                                    const removeType = () => {
                                        const removeUnique = typeActual?.filter(
                                            (e: any) => e?.value !== v?.value
                                        );
                                        setTypeActual(removeUnique);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    };
                                    return (
                                        <button
                                            aria-label={`Botão para remover filtro do tipo ${v?.label}`}
                                            title={`Clique para remover filtro dos tipo ${v?.label}`}
                                            type="button"
                                            className={styles.tags_picker}
                                            onClick={removeType}
                                            key={v?.value}
                                            style={stylesTags2}
                                        >
                                            {v?.label}
                                            <IoCloseSharp
                                                size={16}
                                                color={stylesIconClose}
                                                style={marginIconTag}
                                            />
                                        </button>
                                    );
                                })}
                            </div>
                        ) : null}
                        { site?.exibir_empreendimento ?
                            <div className={styles.adjust_select}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    {site?.id == "1892" ? "RESIDENCIAIS E LOTEAMENTOS" : "CONDOMÍNIOS"}
                                </label>
                                <Select
                                    options={listCompany}
                                    className={styles.select}
                                    placeholder={site?.id == "1892" ? "Residenciais e loteamentos" : "Condomínios"}
                                    styles={colorPickerCompany}
                                    value={companyActual}
                                    onChange={onChangeCompany}
                                    noOptionsMessage={() =>
                                        companyInputActual ? 'Condomínio não encontrado' : 'Busque por um condomínio'
                                    }
                                    inputValue={companyInputActual}
                                    onInputChange={onInputChangeCompany}
                                    instanceId={3}
                                />
                            </div>
                        : null }
                        {companyActual ? (
                            <div className={styles.adjust_tags_filter}>
                                <button
                                    aria-label={`Botão para remover filtro de empreendimento ${companyActual?.label}`}
                                    title={`Clique para remover filtro de empreendimento ${companyActual?.label}`}
                                    type="button"
                                    className={styles.tags_picker}
                                    onClick={() => {setCompanyActual(0);setPage(1);setAutorizaBusca(true);}}
                                    style={stylesTags2}
                                >
                                    {companyActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose}
                                        style={marginIconTag}
                                    />
                                </button>
                            </div>
                        ) : null}
                        { listCategory?.length > 0 ?
                            <div className={styles.adjust_select}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    CATEGORIAS
                                </label>
                                <Select
                                    options={listCategory}
                                    className={styles.select}
                                    placeholder="Categorias"
                                    noOptionsMessage={() => 'Categoria não encontrada!'}
                                    styles={colorPicker}
                                    value={categoryActual}
                                    onChange={onChangeCategory}
                                    instanceId={13}
                                />
                            </div>
                        : null }
                        {categoryActual ? (
                            <div className={styles.adjust_tags_filter}>
                                <button
                                    aria-label={`Botão para remover filtro da categoria ${categoryActual?.label}`}
                                    title={`Clique para remover filtro da categoria ${categoryActual?.label}`}
                                    type="button"
                                    className={styles.tags_picker}
                                    onClick={() => {
                                        setCategoryActual(null);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    }}
                                    style={stylesTags2}
                                >
                                    {categoryActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose}
                                        style={marginIconTag}
                                    />
                                </button>
                            </div>
                        ) : null}
                         { listDatas?.length > 0 && site?.mostrar_data_entrega ?
                            <div className={styles.adjust_select}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    Data de Entrega
                                </label>
                                <Select
                                    options={listDatas}
                                    className={styles.select}
                                    placeholder="Data de entrega"
                                    noOptionsMessage={() => 'Data de entrega não encontrada!'}
                                    styles={colorPicker}
                                    value={dataEntregaActual}
                                    onChange={onChangeDatas}
                                    instanceId={131}
                                />
                            </div>
                        : null }
                        {dataEntregaActual?.length > 0 ? (
                                <div className={styles.adjust_tags_filter}>
                                    {dataEntregaActual?.map((v: any) => {
                                        const removeDtas = () => {
                                            const removeUnique = dataEntregaActual?.filter(
                                                (e: any) => e?.value !== v?.value
                                            );
                                            setDataEntregaActual(removeUnique);
                                            setPage(1);
                                            setAutorizaBusca(true);
                                        };
                                        return (
                                            <button
                                                aria-label={`Botão para remover filtro de data de entrega ${v?.label}`}
                                                title={`Clique para remover filtro de data de entrega ${v?.label}`}
                                                type="button"
                                                className={styles.tags_picker}
                                                onClick={removeDtas}
                                                key={v?.value}
                                                style={stylesTags2}
                                            >
                                                {v?.label}
                                                <IoCloseSharp
                                                    size={16}
                                                    color={stylesIconClose}
                                                    style={marginIconTag}
                                                />
                                            </button>
                                        );
                                    })}
                                </div>
                            ) : null}
                        { listCaract?.length > 0 ?
                            <div className={styles.adjust_select}>
                                <label className={styles.title_select} style={{color: corLetra1}}>
                                    CARACTERÍSTICAS
                                </label>
                                <Select
                                    options={listCaract}
                                    className={styles.select}
                                    placeholder="Características"
                                    noOptionsMessage={() => 'Categoria não encontrada!'}
                                    styles={colorPicker}
                                    value={caractActual}
                                    onChange={onChangeCaracteristicas}
                                    instanceId={0}
                                />
                            </div>
                        : null }
                        {caractActual?.length > 0 ? (
                                <div className={styles.adjust_tags_filter}>
                                    {caractActual?.map((v: any) => {
                                        const removeCaract = () => {
                                            const removeUnique = caractActual?.filter(
                                                (e: any) => e?.value !== v?.value
                                            );
                                            setCaractActual(removeUnique);
                                            setPage(1);
                                            setAutorizaBusca(true);
                                        };
                                        return (
                                            <button
                                                aria-label={`Botão para remover filtro de Característica ${v?.label}`}
                                                title={`Clique para remover filtro do Característica ${v?.label}`}
                                                type="button"
                                                className={styles.tags_picker}
                                                onClick={removeCaract}
                                                key={v?.value}
                                                style={stylesTags2}
                                            >
                                                {v?.label}
                                                <IoCloseSharp
                                                    size={16}
                                                    color={stylesIconClose}
                                                    style={marginIconTag}
                                                />
                                            </button>
                                        );
                                    })}
                                </div>
                            ) : null}
                        <div className={styles.adjust_select}>
                            <label className={styles.title_select} style={{color: corLetra1}}>
                                    ÁREA PRIVATIVA
                            </label>
                            <div className={styles.adjust_select_p} style={{width: "100%",minWidth: "100%",maxWidth: "100%",margin: 0}}>
                                <div className={styles.adjust_select_price1} style={{margin: "0px 2.5% 0px 0px"}}>
                                    <input
                                        className={styles.input}
                                        placeholder={areaAux > 0 ? areaAux[0]+" m²" : "Área Mínima"}
                                        onChange={onChangeAreaMinimo}
                                        inputMode='numeric'
                                        value={areaAux[0] > 0 ? areaAux[0] : ""}
                                        style={{ color: corLetra1,border: `2px solid ${corLetra1}` }}
                                    />
                                </div>
                                <div className={styles.adjust_select_price1} style={{margin: "0px 0px 0px 2.5%"}}>
                                    <input
                                        className={styles.input}
                                        placeholder={areaAux > 0 ? areaAux[1]+" m²" : "Área Máxima"}
                                        onChange={onChangeAreaMaximo}
                                        inputMode='numeric'
                                        value={areaAux[1] > 0 ? areaAux[1] : ""}
                                        style={{ color: corLetra1,border: `2px solid ${corLetra1}` }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={styles.adjust_select}>
                            <label className={styles.title_select} style={{color: corLetra2}}>
                                CÓDIGOS
                            </label>
                            <input
                                className={styles.input}
                                placeholder="Código"
                                onChange={onChangeCode}
                                value={codeInput}
                                style={{ color: corLetra1,border: `2px solid ${corLetra1}` }}
                            />
                        </div>
                        {codeActual ? (
                            <div className={styles.adjust_tags_filter}>
                                <button
                                    aria-label={`Botão para remover filtro por código do imóvel`}
                                    title={`Clique para remover filtro por código do imóvel`}
                                    type="button"
                                    className={styles.tags_picker}
                                    style={stylesTags2}
                                    onClick={() => {setCodeActual('');setPage(1);setAutorizaBusca(true);}}
                                >
                                    {codeActual}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose}
                                        style={marginIconTag}
                                    />
                                </button>
                            </div>
                        ) : null}
                        {['suites_min', 'garagems_min', 'dormitorios_min', 'banheiros_min'].map(
                            (e) => {
                                const RenderTitle = () => {
                                    if (e === 'suites_min') {
                                        return 'Suítes';
                                    }
                                    if (e === 'garagems_min') {
                                        return 'Vagas';
                                    }
                                    if (e === 'dormitorios_min') {
                                        return 'Quartos';
                                    }
                                    if (e === 'banheiros_min') {
                                        return 'Banheiros';
                                    }
                                };
                                return (
                                    <div className={styles.adjust_flex} key={e}>
                                        <label
                                            className={
                                                styles.title_filter_number
                                            }
                                            style={{color: corLetra1}}
                                        >
                                            {RenderTitle()}
                                        </label>
                                        <div className={styles.flex}>
                                            {['1', '2', '3', '4', '5+'].map(
                                                (v) => {
                                                    const getNumber = Number(
                                                        v.replace('+', '')
                                                    );
                                                    const onChangeNumber =
                                                        () => {
                                                            setFilters({
                                                                ...filters,
                                                                [e]:
                                                                    filters[
                                                                        e
                                                                    ] ===
                                                                    getNumber
                                                                        ? 0
                                                                        : getNumber,
                                                            });
                                                            setPage(1);
                                                            setAutorizaBusca(true);
                                                        };
                                                    return (
                                                        <button
                                                            aria-label={`Botão de filtro de imóveis com ${v} ${RenderTitle()}`}
                                                            title={`Clique para buscar imóveis com ${v} ${RenderTitle()}`}
                                                            type="button"
                                                            style={{background: corFundo,color: corLetra1}}
                                                            className={
                                                                filters[e] ===
                                                                getNumber
                                                                    ? styles.button_number_active
                                                                    : styles.button_number
                                                            }
                                                            onClick={
                                                                onChangeNumber
                                                            }
                                                            key={v}
                                                        >
                                                            {v}
                                                        </button>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                        )}
                        {activeLargeFilter ? (
                            <button
                                aria-label={`Botão para concluir busca`}
                                title={`Clique para concluir busca`}
                                type="button"
                                onClick={applyFilter}
                                className={styles.button_concluded}
                                style={isColorLight(site?.cor2) ? {background: site?.cor2,color: site?.cor11} : {background: site?.cor2,color: site?.cor13}}
                            >
                                CONCLUÍDO
                            </button>
                        ) : null}
                        {activeLargeFilter ? (
                            <button
                                aria-label={`Botão para fechar busca personalizada`}
                                title={`Clique para fechar busca personalizada`}
                                type="button"
                                onClick={() => setActiveLargeFilter(false)}
                                className={styles.closed_modal}
                            >
                                <IoCloseSharp
                                    size={24}
                                    color={stylesIconClose}
                                    style={marginIconTag}
                                />
                            </button>
                        ) : null}
                    </motion.div>
                ) : null}
            </>
        );
    };
    return (
        <>
            { mapaOn && allPropertiesMapa?.length > 0 && site?.mostrar_mapa ? <Mapa openMapa={1} setOpenMapa={setMapaOn} prop={allPropertiesMapa[0]} properties={allPropertiesMapa} tipo={0}/> : null}
            {size?.width <= 900 && activeLargeFilter ? (
                <div className={styles.container_large_filter} data-nosnippet>
                    {renderFilters()}
                </div>
            ) : null}
            <div className={styles.container_header}>
                {(renderTextFilters && !loading) || naoEncontrou ?
                    renderTextFilters() :
                    <Box sx={{ height: 87, width: '100%' }}>
                        <Skeleton variant="rectangular" width="40%" height="47px" style={{borderRadius: "10px", margin: 5}}/>
                        <Skeleton variant="rectangular" width="20%" height="30px" style={{borderRadius: "10px", margin: 5}}/>
                    </Box>
                }
                {typeValidation ? (
                    <div className={styles.adjust_tags} data-nosnippet>
                        {openFavoritos && favorito?.length > 0 ?
                            <motion.div
                                key="favoritos_limpar"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 1.2 }}
                            >
                                <button
                                    aria-label={`Botão para limpar todos os imóveis selecionados como favoritos`}
                                    title={`Clique para limpar os imóveis favoritos`}
                                    onClick={() => limpaFavoritos()} className={styles.tags1} style={stylesTags} type="button">
                                    Limpar Favoritos
                                    <FaTrashAlt
                                        size={16}
                                        color={stylesIconClose1}
                                        style={{margin: '0px 0px 5px 0px'}}
                                    />
                                </button>
                                <button
                                    aria-label={`Botão para abrir página com todos os imóveis`}
                                    title={`Clique para ver Todos os imóveis`}
                                    type="button" onClick={() => {setOpenFavoritos(false);setPage(1);setAutorizaBusca(true);}} style={stylesTags} className={styles.tags1}
                                >
                                    Ver Todos Imóveis
                                </button>
                            </motion.div>
                            : null}
                            {estadoActual && (site?.id == 2177 || site?.id == 2297 || site?.id == 1942 || site?.id == 2065) ? (
                                <motion.div
                                    key="estado_1"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.5 }}
                                >
                                    <button
                                        aria-label={`Botão para limpar filtro do Estado ${estadoActual?.label}`}
                                        title={`Clique para limpar filtro do Estado ${estadoActual?.label}`}
                                        type="button"
                                        style={stylesTags}
                                        className={styles.tags}
                                        onClick={() => {
                                            setDistrictActual([]);
                                            setListDistrict([]);
                                            setCityActual(null);
                                            setListCity(allCities);
                                            setEstadoActual(null);
                                            setPage(1);
                                            setAutorizaBusca(true);
                                        }}
                                    >
                                        {estadoActual?.label}
                                        <IoCloseSharp
                                            size={16}
                                            color={stylesIconClose1}
                                            style={marginIconTag}
                                        />
                                    </button>
                                </motion.div>
                            ) : null}
                        {cityActual ? (
                            <motion.div
                                key="cidade_1"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.5 }}
                            >
                                <button
                                    aria-label={`Botão para limpar filtro da cidade ${cityActual?.label}`}
                                    title={`Clique para limpar filtro da cidade ${cityActual?.label}`}
                                    type="button"
                                    style={stylesTags}
                                    className={styles.tags}
                                    onClick={() => {
                                        setCityActual(null);
                                        setDistrictActual([]);
                                        setListDistrict([]);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    }}
                                >
                                    {cityActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        ) : null}
                        {districtActual?.map((v: any, idx: number) => {
                            const removeDistrict = () => {
                                const removeUnique = districtActual?.filter(
                                    (e: any) => e?.value !== v?.value
                                );
                                setDistrictActual(removeUnique);
                                setPage(1);
                                setAutorizaBusca(true);
                            };
                            return (
                                <motion.div
                                    key={`bairro_${v?.value ?? v?.label ?? idx}`}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.6 }}
                                >
                                    <button
                                        aria-label={`Botão para limpar filtro do bairro ${v?.label}`}
                                        title={`Clique para limpar filtro do bairro ${v?.label}`}
                                        type="button"
                                        className={styles.tags}
                                        onClick={removeDistrict}
                                        style={stylesTags}
                                    >
                                        {v?.label}
                                        <IoCloseSharp
                                            size={16}
                                            color={stylesIconClose1}
                                            style={marginIconTag}
                                        />
                                    </button>
                                </motion.div>
                            );
                        })}
                        {typeActual?.map((v: any, idx: number) => {
                            const removeType = () => {
                                const removeUnique = typeActual?.filter(
                                    (e: any) => e?.value !== v?.value
                                );
                                setTypeActual(removeUnique);
                                setPage(1);
                                setAutorizaBusca(true);
                            };
                            return (
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    key={`tipo_${v?.value ?? v?.label ?? idx}`}
                                    transition={{ duration: 0.5, delay: 0.7 }}
                                >
                                    <button
                                        aria-label={`Botão para limpar filtro do tipo ${v?.label}`}
                                        title={`Clique para limpar filtro dos tipo ${v?.label}`}
                                        type="button"
                                        className={styles.tags}
                                        onClick={removeType}
                                        style={stylesTags}
                                    >
                                        {v?.label}
                                        <IoCloseSharp
                                            size={16}
                                            color={stylesIconClose1}
                                            style={marginIconTag}
                                        />
                                    </button>
                                </motion.div>
                            );
                        })}
                        {caractActual?.map((v: any, idx: number) => {
                            const removecar = () => {
                                const removeUnique = caractActual?.filter(
                                    (e: any) => e?.value !== v?.value
                                );
                                setCaractActual(removeUnique);
                                setPage(1);
                                setAutorizaBusca(true);
                            };
                            return (
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    key={`caract_${v?.value ?? v?.label ?? idx}`}
                                    transition={{ duration: 0.5, delay: 0.7 }}
                                >
                                    <button
                                        aria-label={`Botão para limpar filtro da característica ${v?.label}`}
                                        title={`Clique para limpar filtro da característica ${v?.label}`}
                                        type="button"
                                        className={styles.tags}
                                        onClick={removecar}
                                        style={stylesTags}
                                    >
                                        {v?.label}
                                        <IoCloseSharp
                                            size={16}
                                            color={stylesIconClose1}
                                            style={marginIconTag}
                                        />
                                    </button>
                                </motion.div>
                            );
                        })}
                        {companyActual ? (
                            <motion.div
                                key="empreendimento_1"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.8 }}
                            >
                                <button
                                    aria-label={`Botão para limpar filtro do empreendimento ${companyActual?.label}`}
                                    title={`Clique para limpar filtro do empreendimento ${companyActual?.label}`}
                                    type="button"
                                    className={styles.tags}
                                    onClick={() => {setCompanyActual(0);setPage(1);setAutorizaBusca(true);}}
                                    style={stylesTags}
                                >
                                    {companyActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        ) : null}
                        {categoryActual ? (
                            <motion.div
                                key="categoria_1"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 0.9 }}
                            >
                                <button
                                    aria-label={`Botão para remover filtro da categoria ${categoryActual?.label}`}
                                    title={`Clique para remover filtro da categoria ${categoryActual?.label}`}
                                    type="button"
                                    className={styles.tags}
                                    onClick={() => {
                                        setCategoryActual(null);
                                        setPage(1);
                                        setAutorizaBusca(true);
                                    }}
                                    style={stylesTags}
                                >
                                    {categoryActual?.label}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        ) : null}
                        {dataEntregaActual?.map((v: any, idx: number) => {
                            const removdt = () => {
                                const removeUnique = dataEntregaActual?.filter(
                                    (e: any) => e?.value !== v?.value
                                );
                                setDataEntregaActual(removeUnique);
                                setPage(1);
                                setAutorizaBusca(true);
                            };
                            return (
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    key={`data_${v?.value ?? v?.label ?? idx}`}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: 0.7 }}
                                >
                                    <button
                                        aria-label={`Botão para remover filtro de data de entrega ${dataEntregaActual?.label}`}
                                        title={`Clique para remover filtro de data de entrega ${dataEntregaActual?.label}`}
                                        type="button"
                                        className={styles.tags}
                                        onClick={removdt}
                                        style={stylesTags}
                                    >
                                        {v?.label}
                                        <IoCloseSharp
                                            size={16}
                                            color={stylesIconClose1}
                                            style={marginIconTag}
                                        />
                                    </button>
                                </motion.div>
                            );
                        })}
                        {codeActual ? (
                            <motion.div
                                key="codigo_1"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 1 }}
                            >
                                <button
                                    aria-label={`Botão para limpar filtro por código do imóvel: ${codeActual}`}
                                    title={`Clique para limpar filtro por código do imóvel: ${codeActual}`}
                                    type="button"
                                    className={styles.tags}
                                    style={stylesTags}
                                    onClick={() =>
                                        {setCodeActual('');setPage(1);setAutorizaBusca(true);}
                                    }
                                >
                                    {codeActual}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        ) : null}
                        {!type || site?.transacoes?.length <= 1 ? null : (
                            <motion.div
                                key="transacao_1"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: 1.1 }}
                            >
                                <button
                                    aria-label={`Botão para limpar de transação`}
                                    title={`Clique para limpar filtro de transação`}
                                    type="button"
                                    className={styles.tags}
                                    onClick={onChangeType}
                                    style={stylesTags}
                                >
                                    {type === 'sale' ? 'Venda' : ''}
                                    {type === 'rent' ? 'Aluguel' : ''}
                                    {type === 'temporada' ? 'Temporada' : ''}
                                    <IoCloseSharp
                                        size={16}
                                        color={stylesIconClose1}
                                        style={marginIconTag}
                                    />
                                </button>
                            </motion.div>
                        )}
                    </div>
                ) : null}
            </div>
            <div className={styles.container_select} data-nosnippet>
                {size?.width <= 900 && typeValidation ? (
                    <button
                        aria-label={`Botão para abrir filtros personalizados`}
                        title={`Clique para abrir filtros personalizados`}
                        type="button"
                        className={styles.mapa_button}
                        style={{borderColor: corLetra2,color: corLetra2}}
                        onClick={openFilter}
                    >
                        <IoFilterOutline
                            size={24}
                            color={corLetra2}
                            style={{ marginRight: 5 }}
                        />
                        Filtrar
                    </button>
                ) : null}
                { !isMobile && size?.width > 1150 && typeValidation ?
                    <button
                        aria-label={`Botão para alterar apresentação dos cards de imóveis`}
                        title={`Clique para alterar apresentação dos cards de imóveis`}
                        type="button" onClick={() => positionCard ? setPositionCard(0) : setPositionCard(1)} style={{background: "none",margin: "0px 13px 6px 5px",border: "none",padding: "0px"}}>
                        { isHorizontalCardLayout ?
                            <FaTh
                                size={25}
                                color={corLetra2}
                                style={{margin: '0px', cursor: 'pointer'}}
                            />
                        :
                            <FaThList
                                size={25}
                                color={corLetra2}
                                style={{margin: '0px',  cursor: 'pointer'}}
                            />
                        }
                    </button>
                : null }
                { allPropertiesMapa?.length > 0 && site?.mostrar_mapa && typeValidation ?
                    <button
                        aria-label={`Botão para ver imóveis no Mapa`}
                        title={`Clique para ver imóveis no Mapa`}
                        style={{borderColor: corLetra2,color: corLetra2}}
                        type="button" onClick={() => setMapaOn(1)} className={styles.mapa_button}>
                        <HiMapPin
                            size={15}
                            color={corLetra2}
                            style={{margin: '0px 5px 0px 0px'}}
                        />
                        Mapa
                    </button> : null }
                {typeValidation && site?.id != '2049' ? (
                    <div
                        className={`${styles.adjust_select_order} ${orderMenuInteractionLocked ? styles.adjust_select_order_open : ''}`}
                        onClick={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                        onPointerDown={(e) => e.stopPropagation()}
                    >
                        <Select
                            ref={orderSelectRef}
                            options={[
                                {
                                    label: 'Mais Recentes',
                                    value: 'desc-inclusao',
                                },
                                {
                                    label: 'Mais Antigos',
                                    value: 'asc-inclusao',
                                },
                                {
                                    label: 'Maior Valor',
                                    value: 'desc-valor',
                                },
                                {
                                    label: 'Menor Valor',
                                    value: 'asc-valor',
                                },
                                {
                                    label: 'Mais Visitados',
                                    value: 'desc-visualizacao',
                                },
                                {
                                    label: 'Menos Visitados',
                                    value: 'asc-visualizacao',
                                },
                                {
                                    label: 'Exclusivos',
                                    value: 'asc-exclusivos',
                                },
                            ]}
                            className={styles.select_order}
                            placeholder="Ordenar"
                            styles={orderSelectStyles}
                            value={orderActual}
                            onChange={onChangeOrder}
                            onMenuOpen={handleOrderMenuOpen}
                            onMenuClose={handleOrderMenuClose}
                            menuIsOpen={!activeLargeFilter && orderMenuOpen}
                            menuPortalTarget={activeLargeFilter ? undefined : orderSelectPortalTarget}
                            menuPosition="fixed"
                            menuShouldBlockScroll={true}
                            instanceId={4}
                        />
                    </div>
                ) : null}
            </div>
            {site?.exibir_empreendimento && typeValidation && !loading && !empreendimentoDetalheLoading && empreendimentoResumo ? (
                <Link
                    href={empreendimentoResumo.href}
                    className={styles.empreendimentoSpotlight}
                    aria-label={`Ver detalhes do empreendimento ${empreendimentoResumo.nome}`}
                >
                    <div className={styles.empreendimentoSpotlightMedia}>
                        <Image
                            src={empreendimentoResumo.foto}
                            alt={empreendimentoResumo.nome}
                            fill
                            sizes="(max-width: 900px) 100vw, 360px"
                            className={styles.empreendimentoSpotlightImage}
                        />
                        <span className={styles.empreendimentoSpotlightBadge}>
                            {empreendimentoResumo.categoria || 'Empreendimento'}
                        </span>
                    </div>
                    <div className={styles.empreendimentoSpotlightContent}>
                        <h2 className={styles.empreendimentoSpotlightTitle}>{empreendimentoResumo.nome}</h2>
                        {empreendimentoResumo.localizacao ? (
                            <p className={styles.empreendimentoSpotlightLocation}>
                                <HiMapPin size={16} />
                                <span>{empreendimentoResumo.localizacao}</span>
                            </p>
                        ) : null}
                        {empreendimentoResumo?.caracteristicas?.length > 0 ? (
                            <div className={styles.empreendimentoSpotlightFeatureList}>
                                {empreendimentoResumo.caracteristicas.map((item: string) => (
                                    <span key={`${empreendimentoResumo.nome}-${item}`} className={styles.empreendimentoSpotlightFeatureTag}>
                                        {item}
                                    </span>
                                ))}
                            </div>
                        ) : null}
                        {empreendimentoResumo?.highlights?.length > 0 ? (
                            <div className={styles.empreendimentoSpotlightHighlights}>
                                {empreendimentoResumo.highlights.map((item: any) => (
                                    <div key={item.key} className={styles.empreendimentoSpotlightHighlightItem}>
                                        {item.icon === 'dormitorios' ? (
                                            <FaBed className={styles.empreendimentoSpotlightHighlightIcon} />
                                        ) : null}
                                        {item.icon === 'area' ? (
                                            <FaRulerCombined className={styles.empreendimentoSpotlightHighlightIcon} />
                                        ) : null}
                                        {item.icon === 'banheiros' ? (
                                            <FaBath className={styles.empreendimentoSpotlightHighlightIcon} />
                                        ) : null}
                                        {item.icon === 'vagas' ? (
                                            <FaCar className={styles.empreendimentoSpotlightHighlightIcon} />
                                        ) : null}
                                        <span>{item.label}</span>
                                    </div>
                                ))}
                            </div>
                        ) : null}
                        <div className={styles.empreendimentoSpotlightStats}>
                            <div className={styles.empreendimentoSpotlightStat}>
                                <span className={styles.empreendimentoSpotlightLabel}>Faixa de preco</span>
                                <strong>{empreendimentoResumo.faixaPreco || 'Consulte'}</strong>
                            </div>
                            <div className={styles.empreendimentoSpotlightStat}>
                                <span className={styles.empreendimentoSpotlightLabel}>Area privativa</span>
                                <strong>{empreendimentoResumo.faixaArea || 'Consulte'}</strong>
                            </div>
                            <div className={styles.empreendimentoSpotlightStat}>
                                <span className={styles.empreendimentoSpotlightLabel}>Situacao</span>
                                <strong>{empreendimentoResumo.situacao || 'Disponivel'}</strong>
                            </div>
                        </div>
                    </div>
                </Link>
            ) : null}
            <div className={styles.container_all_list}>
            <div className={styles.geral}>
            {(agenciador && site?.exibir_agenciador && managerActual?.url_foto && typeValidation) ? (
                <>
                    <IconButton aria-label="delete" className={styles.button_delete} onClick={() => {setAgenciador(0);setPage(1);setAutorizaBusca(true);}}>
                        <CloseIcon/>
                    </IconButton>
                    <div key={managerActual?.id} className={styles.info_manager}>
                        {status === 'valid' ? (
                            <Image style={{border:"1px solid" +site?.cor2}} width={215} height={215} src={managerActual?.url_foto.replace("_g","_m")} alt="Foto Corretor" className={styles.img}></Image>
                        ) : null}
                        <div className={styles.info}>
                            <label className={styles.name}>{managerActual?.nome}</label>
                            {site?.id != '2091' ?
                                <label className={styles.manager}>{managerActual?.funcao?.nome}</label>
                            : null}
                            <div>
                                {managerActual?.instagram ? (
                                    <a
                                        href={managerActual?.instagram}
                                        target="_blank"
                                        rel="noreferrer"
                                        className={styles.network}
                                    >
                                        <svg viewBox="0 0 48 48" height={28} width={28}>
                                            <path d="M 16.5 5 C 10.16639 5 5 10.16639 5 16.5 L 5 31.5 C 5 37.832757 10.166209 43 16.5 43 L 31.5 43 C 37.832938 43 43 37.832938 43 31.5 L 43 16.5 C 43 10.166209 37.832757 5 31.5 5 L 16.5 5 z M 16.5 8 L 31.5 8 C 36.211243 8 40 11.787791 40 16.5 L 40 31.5 C 40 36.211062 36.211062 40 31.5 40 L 16.5 40 C 11.787791 40 8 36.211243 8 31.5 L 8 16.5 C 8 11.78761 11.78761 8 16.5 8 z M 34 12 C 32.895 12 32 12.895 32 14 C 32 15.105 32.895 16 34 16 C 35.105 16 36 15.105 36 14 C 36 12.895 35.105 12 34 12 z M 24 14 C 18.495178 14 14 18.495178 14 24 C 14 29.504822 18.495178 34 24 34 C 29.504822 34 34 29.504822 34 24 C 34 18.495178 29.504822 14 24 14 z M 24 17 C 27.883178 17 31 20.116822 31 24 C 31 27.883178 27.883178 31 24 31 C 20.116822 31 17 27.883178 17 24 C 17 20.116822 20.116822 17 24 17 z"/>
                                        </svg>
                                    </a>
                                ) : null}
                                {managerActual?.telefone ? (
                                    <a
                                        href={managerActual?.internacional ? `https://api.whatsapp.com/send?phone=${managerActual?.telefone?.replace(
                                                /\D/g,
                                                ''
                                            )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"} ` : `https://api.whatsapp.com/send?phone=55${managerActual?.telefone?.replace(
                                                /\D/g,
                                                ''
                                            )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"} `}
                                        onClick={async (e) => {
                                            e.preventDefault(); // Evita o redirecionamento automático

                                            trackLead(site, null); // 🔥 Registra o evento Lead

                                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                            setTimeout(() => {
                                            window.open(
                                                managerActual?.internacional ? `https://api.whatsapp.com/send?phone=${managerActual?.telefone?.replace(
                                                    /\D/g,
                                                    ''
                                                )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"} ` : `https://api.whatsapp.com/send?phone=55${managerActual?.telefone?.replace(
                                                    /\D/g,
                                                    ''
                                                )}&text=${site?.texto_botao_whats ? site?.texto_botao_whats : "Olá, estou visitando o site da "+site?.titulo+", gostaria de um atendimento personalizado. Pode me ajudar?"} `,
                                                "_blank"
                                            );
                                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                        }}
                                        rel="noreferrer"
                                        className={styles.network}
                                    >
                                        <svg viewBox="0 0 32 32" height="30px" width="30px" fill="#34af23">
                                            <path d="M 24.503906 7.503906 C 22.246094 5.246094 19.246094 4 16.050781 4 C 9.464844 4 4.101562 9.359375 4.101562 15.945312 C 4.097656 18.050781 4.648438 20.105469 5.695312 21.917969 L 4 28.109375 L 10.335938 26.445312 C 12.078125 27.398438 14.046875 27.898438 16.046875 27.902344 L 16.050781 27.902344 C 22.636719 27.902344 27.996094 22.542969 28 15.953125 C 28 12.761719 26.757812 9.761719 24.503906 7.503906 Z M 16.050781 25.882812 L 16.046875 25.882812 C 14.265625 25.882812 12.515625 25.402344 10.992188 24.5 L 10.628906 24.285156 L 6.867188 25.269531 L 7.871094 21.605469 L 7.636719 21.230469 C 6.640625 19.648438 6.117188 17.820312 6.117188 15.945312 C 6.117188 10.472656 10.574219 6.019531 16.054688 6.019531 C 18.707031 6.019531 21.199219 7.054688 23.074219 8.929688 C 24.949219 10.808594 25.980469 13.300781 25.980469 15.953125 C 25.980469 21.429688 21.523438 25.882812 16.050781 25.882812 Z M 21.496094 18.445312 C 21.199219 18.296875 19.730469 17.574219 19.457031 17.476562 C 19.183594 17.375 18.984375 17.328125 18.785156 17.625 C 18.585938 17.925781 18.015625 18.597656 17.839844 18.796875 C 17.667969 18.992188 17.492188 19.019531 17.195312 18.871094 C 16.894531 18.722656 15.933594 18.40625 14.792969 17.386719 C 13.90625 16.597656 13.304688 15.617188 13.132812 15.320312 C 12.957031 15.019531 13.113281 14.859375 13.261719 14.710938 C 13.398438 14.578125 13.5625 14.363281 13.710938 14.1875 C 13.859375 14.015625 13.910156 13.890625 14.011719 13.691406 C 14.109375 13.492188 14.058594 13.316406 13.984375 13.167969 C 13.910156 13.019531 13.3125 11.546875 13.0625 10.949219 C 12.820312 10.367188 12.574219 10.449219 12.390625 10.4375 C 12.21875 10.429688 12.019531 10.429688 11.820312 10.429688 C 11.621094 10.429688 11.296875 10.503906 11.023438 10.804688 C 10.75 11.101562 9.980469 11.824219 9.980469 13.292969 C 9.980469 14.761719 11.050781 16.183594 11.199219 16.382812 C 11.347656 16.578125 13.304688 19.59375 16.300781 20.886719 C 17.011719 21.195312 17.566406 21.378906 18 21.515625 C 18.714844 21.742188 19.367188 21.710938 19.882812 21.636719 C 20.457031 21.550781 21.648438 20.914062 21.898438 20.214844 C 22.144531 19.519531 22.144531 18.921875 22.070312 18.796875 C 21.996094 18.671875 21.796875 18.597656 21.496094 18.445312 Z M 21.496094 18.445312 "/>
                                        </svg>
                                    </a>
                                ) : null}
                                {managerActual?.facebook ? (
                                    <a
                                        href={managerActual?.facebook}
                                        target="_blank"
                                        rel="noreferrer"
                                        className={styles.network}
                                    >
                                        <svg viewBox="0 0 32 32" height="30px" width="30px">
                                            <path d="M 16 4 C 9.3844276 4 4 9.3844276 4 16 C 4 22.615572 9.3844276 28 16 28 C 22.615572 28 28 22.615572 28 16 C 28 9.3844276 22.615572 4 16 4 z M 16 6 C 21.534692 6 26 10.465308 26 16 C 26 21.027386 22.311682 25.161277 17.488281 25.878906 L 17.488281 18.916016 L 20.335938 18.916016 L 20.783203 16.023438 L 17.488281 16.023438 L 17.488281 14.443359 C 17.488281 13.242359 17.882859 12.175781 19.005859 12.175781 L 20.810547 12.175781 L 20.810547 9.6523438 C 20.493547 9.6093438 19.822688 9.515625 18.554688 9.515625 C 15.906688 9.515625 14.355469 10.913609 14.355469 14.099609 L 14.355469 16.023438 L 11.632812 16.023438 L 11.632812 18.916016 L 14.355469 18.916016 L 14.355469 25.853516 C 9.6088556 25.070647 6 20.973047 6 16 C 6 10.465308 10.465308 6 16 6 z"/>
                                        </svg>
                                    </a>
                                ) : null}
                                {managerActual?.linkedin ? (
                                    <a
                                        href={managerActual?.linkedin}
                                        target="_blank"
                                        rel="noreferrer"
                                        className={styles.network}
                                    >
                                        <Image
                                            src={IconLinkedin}
                                            height={30}
                                            width={30}
                                            objectFit="contain"
                                            alt="Icone Linkedin"
                                        />
                                    </a>
                                ) : null}
                            </div>
                            {managerActual?.creci ? (
                                <label
                                    className={styles.creci}
                                >{`Creci: ${managerActual?.creci}`}</label>
                            ) : null}
                        </div>
                    </div>
                </>
            ) : null}
                {size?.width > 900 ? renderFilters() : null}
                </div>
                {loading === false ? (
                    <div
                        className={`${typeValidation ? styles.container : styles.container_company} ${orderMenuInteractionLocked ? styles.cards_interaction_locked : ''}`}
                    >
                        { isHorizontalCardLayout ?
                            allProperties?.map((v: any, i: number) => (
                                <motion.div
                                    key={v?.id}
                                    initial={motionBase.initial as any}
                                    animate={motionBase.animate as any}
                                    transition={disableEntryMotion ? { duration: 0 } : { duration: 0.5, delay: i * 0.2 }}
                                    className={styles.card_horizontal1}
                                >
                                    <CardApartamentHorizontal
                                        slide={v}
                                        i={i}
                                        key={v?.id}
                                        site={site}
                                        stylesCard={styles.card_horizontal}
                                        allViewProperties={allViewProperties}
                                        favorito={favorito}
                                        setFavorito={setFavorito}
                                    />
                                </motion.div>
                            ))
                        :
                            allProperties?.map((v: any, i: number) => (
                                <motion.div
                                    key={v?.id}
                                    initial={motionBase.initial as any}
                                    animate={motionBase.animate as any}
                                    transition={disableEntryMotion ? { duration: 0 } : { duration: 0.5, delay: i * 0.2 }}
                                    className={site?.modelo_card > 1 ? styles.card11 : typeValidation
                                        ? styles.card1
                                        : styles.card_company1}
                                >
                                    {site?.modelo_card == 2 ?
                                    <CardApartament1
                                        slide={v}
                                        i={i}
                                        key={v?.id}
                                        site={site}
                                        stylesCard={styles.card3}
                                        allViewProperties={allViewProperties}
                                        favorito={favorito}
                                        codsite={codsite2}
                                    /> : site?.modelo_card == 1 ?
                                    <CardApartament
                                        slide={v}
                                        i={i}
                                        key={v?.id}
                                        site={site}
                                        stylesCard={styles.card2}
                                        allViewProperties={allViewProperties}
                                        favorito={favorito}
                                        codsite={codsite2}
                                    /> :
                                    <CardApartament3
                                        slide={v}
                                        i={i}
                                        key={v?.id}
                                        site={site}
                                        stylesCard={styles.card2}
                                        allViewProperties={allViewProperties}
                                        favorito={favorito}
                                        codsite={codsite2}
                                    />
                                    }
                                </motion.div>
                            ))
                        }
                    </div>
                ) : null}
                {loading ? (
                    naoEncontrou ?
                        <div className={styles.adjust_loading}>
                            {   openFavoritos ?
                                <>
                                    <p className={styles.texto} style={{color: corLetra2}}>Nenhum imóvel favorito encontrado com esse filtro !!</p>
                                    <button
                                        aria-label={`Botão para abrir página com imóveis favoritos`}
                                        title={`Clique para ver imóveis favoritos`}
                                        type="button" onClick={() => {setOpenFavoritos(false);setPage(1);setAutorizaBusca(true);}} className={styles.clique_aqui} style={{color: corLetra2}}>Buscar em todos os imóveis</button>
                                </>
                            :
                                <>
                                    <p className={styles.texto} style={{color: corLetra2}}>Nenhum imóvel encontrado para o filtro selecionado.</p>
                                    {zeraFiltros ? (
                                        <button
                                            aria-label="Botão para ver todos os imóveis"
                                            title="Clique para ver todos os imóveis"
                                            type="button"
                                            onClick={() => { setPage(1); zeraFiltros(); }}
                                            className={styles.ver_todos_btn}
                                            style={{
                                                backgroundColor: site?.cor2,
                                                color: isColorLight(site?.cor2) ? site?.cor11 : site?.cor13,
                                            }}
                                        >
                                            Ver todos os imóveis
                                        </button>
                                    ) : null}
                                </>
                            }
                        </div>
                        :
                        <div className={styles.adjust_loading}>
                            <TailSpin
                                color="rgb(195, 167, 96)"
                                height={80}
                                width={80}
                            />
                        </div>
                ) : null}
            </div>
            {allProperties?.length > 0 ? (
                <div
                    className={
                        !typeValidation
                            ? styles.header_box_company
                            : styles.header_box
                    }
                >
                    <Stack
                        spacing={2}
                        className={isSite2507 ? styles.paginationSite2507 : undefined}
                        style={
                            isSite2507
                                ? ({
                                    ['--pagination-site-color' as any]: corLetra2,
                                    ['--pagination-site-background' as any]: corFundo,
                                    ['--pagination-site-selected-text' as any]: isColorLight(corLetra2) ? '#000000' : '#ffffff',
                                    ['--pagination-site-border' as any]: hexToRgba(corLetra2, 0.18),
                                    ['--pagination-site-hover' as any]: hexToRgba(corLetra2, 0.12),
                                    ['--pagination-site-hover-border' as any]: hexToRgba(corLetra2, 0.34)
                                } as React.CSSProperties)
                                : undefined
                        }
                    >
                        <Pagination
                            count={Math.ceil(qtd / 12)}
                            page={page}
                            sx={{
                                '& .MuiPaginationItem-root': {
                                fontSize: '1.3rem',  // Ajuste o tamanho da fonte conforme necessário
                                height: '40px',
                                width: '40px',
                                color: corLetra2
                            },
                            }}
                            onChange={handleChange}
                        />
                    </Stack>
                </div>
            ) : null}
        </>
    );

};

export default ListPiecesProperties;

export const getServerSideProps = async () => ({ notFound: true });
